import { useQuery, useMutation } from "@tanstack/react-query"
import { getGroupList, getGroupDetail, createGroup, modifyGroup, deleteGroup, modifyGroupMember } from "./service"

/**
 * admin/Group
 */

export const useGroupList = () =>
    useQuery({
        queryKey: ["groupList"],
        queryFn: getGroupList,
    })

export const useGroupDetail = (groupIdx) =>
    useQuery({
        queryKey: ["groupDetail", groupIdx],
        queryFn: () => getGroupDetail(groupIdx),
        enabled: !!groupIdx
    })

export const useCreateGroup = () => {
    return useMutation({
        mutationKey: ["adminGroupCreate"],
        mutationFn: ({ title, description }) => createGroup({ title, description }),
    })
}

export const useModifyGroup = () => {
    return useMutation({
        mutationKey: ["adminGroupModify"],
        mutationFn: ({ idx, title, description }) => modifyGroup({ idx, title, description }),
    })
}

export const useModifyGroupMember = () => {
    return useMutation({
        mutationKey: ["adminGroupMemberModify"],
        mutationFn: ({ groupIdx, userIdxList }) => modifyGroupMember({ groupIdx, userIdxList }),
    })
}

export const useDeleteGroup = () => {
    return useMutation({
        mutationKey: ["adminGroupDelete"],
        mutationFn: (idx) => deleteGroup(idx),
    })
}